export const heroDetailsSelector = state => state.whiteLabel.heroDetails.get('list');
export const HeroDetailsLoadingSelector = state => state.whiteLabel.heroDetails.get('isLoading');